<template>
  <div
    class="noSelect relative z-0 select-none bg-white xs:border xs:shadow-md md:h-12"
  >
    <div
      id="subMenu"
      class="navbar brand-heading noSelect button-font flex cursor-pointer select-none justify-between overflow-y-scroll
      text-center text-base tracking-wider text-gray-800 md:float-left"
      style="max-width: 100vw; scroll-behavior: smooth;"
    >
      <div
        v-for="(item, index) in subMenuItems"
        :id="item"
        :key="index"
        :class="(view === item)?'border-inside-bottom-brand-800':'hover:border-inside-bottom-secondary-300 transition-400 transition-ease'"
        class="item button-font flex w-full select-none items-center justify-center whitespace-nowrap p-3 px-6 transition-all xs:border-r md:w-auto"
        @click="showView(item)"
      >
        {{ item }}
        <div
          v-if="itemNotifications !== undefined && itemNotifications[index] !== null && itemNotifications[index] > 0"
          class="default-font ml-1 flex items-center justify-center rounded-full bg-red-700 p-0 text-center text-sm leading-none text-white"
          style="padding-left: 4px; padding-right: 4px; margin-top: 4px; margin-bottom: 4px;"
        >
          {{ itemNotifications[index] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    subMenuItems: {
      type: Array,
      default: null,
    },
    itemNotifications: {
      type: Array,
      default: undefined,
    },
    defaultView: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      view: '',
      submenuDropdownOpen: false,
    };
  },

  computed: {
    filteredItems() {
      return this.subMenuItems.filter(i => i !== this.view);
    },

    currentView() {
      return this.defaultView;
    },
  },

  watch: {
    currentView() {
      this.scrollToView(this.currentView);
      this.view = this.currentView;
    },
  },

  mounted() {
    if (this.defaultView === null) {
      this.view = this.subMenuItems[0];
    } else {
      this.scrollToView(this.defaultView);
      this.view = this.defaultView;
    }
  },

  methods: {
    scrollToView(target) {
      // Check if selected view is currently being displayed, if not scroll to it
      const doc = document.getElementById('subMenu');
      const left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
      const rect = document.getElementById(target).getBoundingClientRect();

      if ((left + screen.width) < rect.right) {
        doc.scrollLeft = rect.right;
      }
    },

    showView(view) {
      this.view = view;
      this.$emit('click', view);
    },
  },
};
</script>

<style>
  /* Hide scrollbar for Chrome, Safari and Opera */
.navbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.navbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.button-font{
  font-family: var(--button-font);
}


</style>
